export default "55519c58a9e619bc.svg"